// extracted by mini-css-extract-plugin
export default {"container":"WDQgi2EH54fEvkX_ogQs","limitedWidth":"uo1zv2VqKLv5myLJ58Aj","modal":"I6gfzVFOpNs82gAqlQN5","topPositioned":"otQdCfwfI86AWayIAIOI"};